__turbopack_context__.v({
  "additionalContent": "BCgZHW_additionalContent",
  "divider": "BCgZHW_divider",
  "explanation": "BCgZHW_explanation",
  "footnote": "BCgZHW_footnote",
  "fourColumn": "BCgZHW_fourColumn",
  "header": "BCgZHW_header",
  "heading": "BCgZHW_heading",
  "icon": "BCgZHW_icon",
  "iconTextBox": "BCgZHW_iconTextBox",
  "iconTextBoxes": "BCgZHW_iconTextBoxes",
  "text": "BCgZHW_text",
});
